import StockClose from '@/api/stock/stock-close'

import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  edit_data: {},
  status_id: null,
  cycle_month: moment().format('M-YYYY')
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_STATUS_ID(state, data) {
    state.status_id = data
  },
  SET_MONTH(state, date) {
    state.cycle_month = date
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search,
          cycle_month: context.state.cycle_month,
          status: context.state.status_id
        }
      },
      attrubutes
    )
    return StockClose.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return StockClose.store(data)
  },
  update(context, { id, data }) {
    return StockClose.update(id, data)
  },

  async checkIsAllowClose(context, data) {
    return await StockClose.checkIsAllowClose(data)
  },

  reOpen(context, data) {
    return StockClose.reOpen(data)
  }
}
